function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Location from '../geom/Location';
import EdgeEnd from './EdgeEnd';
import Position from './Position';
import TopologyException from '../geom/TopologyException';
import Label from './Label';
var DirectedEdge = /*#__PURE__*/function (_EdgeEnd) {
  function DirectedEdge() {
    var _this;
    _classCallCheck(this, DirectedEdge);
    _this = _callSuper(this, DirectedEdge);
    DirectedEdge.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(DirectedEdge, _EdgeEnd);
  return _createClass(DirectedEdge, [{
    key: "getNextMin",
    value: function getNextMin() {
      return this._nextMin;
    }
  }, {
    key: "getDepth",
    value: function getDepth(position) {
      return this._depth[position];
    }
  }, {
    key: "setVisited",
    value: function setVisited(isVisited) {
      this._isVisited = isVisited;
    }
  }, {
    key: "computeDirectedLabel",
    value: function computeDirectedLabel() {
      this._label = new Label(this._edge.getLabel());
      if (!this._isForward) this._label.flip();
    }
  }, {
    key: "getNext",
    value: function getNext() {
      return this._next;
    }
  }, {
    key: "setDepth",
    value: function setDepth(position, depthVal) {
      if (this._depth[position] !== -999) {
        if (this._depth[position] !== depthVal) throw new TopologyException('assigned depths do not match', this.getCoordinate());
      }
      this._depth[position] = depthVal;
    }
  }, {
    key: "isInteriorAreaEdge",
    value: function isInteriorAreaEdge() {
      var isInteriorAreaEdge = true;
      for (var i = 0; i < 2; i++) {
        if (!(this._label.isArea(i) && this._label.getLocation(i, Position.LEFT) === Location.INTERIOR && this._label.getLocation(i, Position.RIGHT) === Location.INTERIOR)) {
          isInteriorAreaEdge = false;
        }
      }
      return isInteriorAreaEdge;
    }
  }, {
    key: "setNextMin",
    value: function setNextMin(nextMin) {
      this._nextMin = nextMin;
    }
  }, {
    key: "print",
    value: function print(out) {
      _superPropGet(DirectedEdge, "print", this, 1).call(this, out);
      out.print(' ' + this._depth[Position.LEFT] + '/' + this._depth[Position.RIGHT]);
      out.print(' (' + this.getDepthDelta() + ')');
      if (this._isInResult) out.print(' inResult');
    }
  }, {
    key: "setMinEdgeRing",
    value: function setMinEdgeRing(minEdgeRing) {
      this._minEdgeRing = minEdgeRing;
    }
  }, {
    key: "isLineEdge",
    value: function isLineEdge() {
      var isLine = this._label.isLine(0) || this._label.isLine(1);
      var isExteriorIfArea0 = !this._label.isArea(0) || this._label.allPositionsEqual(0, Location.EXTERIOR);
      var isExteriorIfArea1 = !this._label.isArea(1) || this._label.allPositionsEqual(1, Location.EXTERIOR);
      return isLine && isExteriorIfArea0 && isExteriorIfArea1;
    }
  }, {
    key: "setEdgeRing",
    value: function setEdgeRing(edgeRing) {
      this._edgeRing = edgeRing;
    }
  }, {
    key: "getMinEdgeRing",
    value: function getMinEdgeRing() {
      return this._minEdgeRing;
    }
  }, {
    key: "getDepthDelta",
    value: function getDepthDelta() {
      var depthDelta = this._edge.getDepthDelta();
      if (!this._isForward) depthDelta = -depthDelta;
      return depthDelta;
    }
  }, {
    key: "setInResult",
    value: function setInResult(isInResult) {
      this._isInResult = isInResult;
    }
  }, {
    key: "getSym",
    value: function getSym() {
      return this._sym;
    }
  }, {
    key: "isForward",
    value: function isForward() {
      return this._isForward;
    }
  }, {
    key: "getEdge",
    value: function getEdge() {
      return this._edge;
    }
  }, {
    key: "printEdge",
    value: function printEdge(out) {
      this.print(out);
      out.print(' ');
      if (this._isForward) this._edge.print(out);else this._edge.printReverse(out);
    }
  }, {
    key: "setSym",
    value: function setSym(de) {
      this._sym = de;
    }
  }, {
    key: "setVisitedEdge",
    value: function setVisitedEdge(isVisited) {
      this.setVisited(isVisited);
      this._sym.setVisited(isVisited);
    }
  }, {
    key: "setEdgeDepths",
    value: function setEdgeDepths(position, depth) {
      var depthDelta = this.getEdge().getDepthDelta();
      if (!this._isForward) depthDelta = -depthDelta;
      var directionFactor = 1;
      if (position === Position.LEFT) directionFactor = -1;
      var oppositePos = Position.opposite(position);
      var delta = depthDelta * directionFactor;
      var oppositeDepth = depth + delta;
      this.setDepth(position, depth);
      this.setDepth(oppositePos, oppositeDepth);
    }
  }, {
    key: "getEdgeRing",
    value: function getEdgeRing() {
      return this._edgeRing;
    }
  }, {
    key: "isInResult",
    value: function isInResult() {
      return this._isInResult;
    }
  }, {
    key: "setNext",
    value: function setNext(next) {
      this._next = next;
    }
  }, {
    key: "isVisited",
    value: function isVisited() {
      return this._isVisited;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return DirectedEdge;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "depthFactor",
    value: function depthFactor(currLocation, nextLocation) {
      if (currLocation === Location.EXTERIOR && nextLocation === Location.INTERIOR) return 1;else if (currLocation === Location.INTERIOR && nextLocation === Location.EXTERIOR) return -1;
      return 0;
    }
  }]);
}(EdgeEnd);
export { DirectedEdge as default };
DirectedEdge.constructor_ = function () {
  this._isForward = null;
  this._isInResult = false;
  this._isVisited = false;
  this._sym = null;
  this._next = null;
  this._nextMin = null;
  this._edgeRing = null;
  this._minEdgeRing = null;
  this._depth = [0, -999, -999];
  var edge = arguments[0];
  var isForward = arguments[1];
  EdgeEnd.constructor_.call(this, edge);
  this._isForward = isForward;
  if (isForward) {
    this.init(edge.getCoordinate(0), edge.getCoordinate(1));
  } else {
    var n = edge.getNumPoints() - 1;
    this.init(edge.getCoordinate(n), edge.getCoordinate(n - 1));
  }
  this.computeDirectedLabel();
};